import posthog from 'posthog-js';
import { POSTHOG_API_KEY, POSTHOG_HOST } from '../constants';

export const initAnalytics = (): void => {
  if (POSTHOG_API_KEY && typeof window !== 'undefined') {
    try {
      posthog.init(POSTHOG_API_KEY, {
        api_host: POSTHOG_HOST,
        autocapture: true,
        capture_pageview: true,
        persistence: 'localStorage'
      });
      console.log('Analytics initialized');
    } catch (error) {
      console.warn('Failed to initialize PostHog', error);
    }
  }
};

export const trackEvent = (eventName: string, properties?: Record<string, any>): void => {
  if (POSTHOG_API_KEY) {
    posthog.capture(eventName, properties);
  }
};
